import request from "@/utils/request";
import type { QueryParams, RuleForm } from "@/types/type";
import type { ApiResponse, MenuResponse, StandardForm } from "@/types/menu";

// 新增标准
export function addStandard(data: {
  standardName: string; // 必填
  standardNumber: string; // 必填
  responsibleUnit?: string;
  publicationDate?: string; // YYYY-MM-DD HH:mm:ss
  implementationDate?: string; // YYYY-MM-DD HH:mm:ss
  scope?: string;
  departmentName?: string;
  draftAuthor?: string;
  draftUnit?: string;
  normativeDocuments?: string;
  level?: string;
  imageList?: string[];
}) {
  return request<ApiResponse>({
    url: "/admin/standard/plus",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

export function listStandardByPage(query: QueryParams) {
  return request({
    url: "/common/standard",
    method: "get",
    params: {
      // 使用 params 而不是 query
      page: query.page,
      pageSize: query.pageSize,
      key: query.key,
      level: query.level,
    },
  });
}
// 获取标准详情
export const getStandardById = (id: string | number) => {
  return request({
    url: `/common/standard/${id}`,
    method: "get",
  });
};

// 删除标准
export function deleteStandard(id: string) {
  return request({
    url: "/admin/standard/" + id,
    method: "delete",
  });
}
// 更新标准 - 修改函数签名，分别接收 id 和数据
export function updateStandard(data: {
  id: string | number;
  standardName: string;
  standardNumber: string;
  responsibleUnit?: string;
  publicationDate?: string; // YYYY-MM-DD HH:mm:ss
  implementationDate?: string; // YYYY-MM-DD HH:mm:ss
  scope?: string;
  departmentName?: string;
  draftAuthor?: string;
  draftUnit?: string;
  normativeDocuments?: string;
  level?: string;
  imageList?: string[]; // 支持多图上传
  image?: string; // 保持兼容
}) {
  return request({
    url: `/admin/standard`, // 使用模板字符串正确拼接 id
    method: "put",
    data,
  });
}

// 批量删除标准
export function deleteStandardBatch(ids: string[]) {
  return request({
    url: `/admin/standard/batch/${ids.join(",")}`, // 将数组转换为逗号分隔的字符串
    method: "delete",
  });
}

// 获取标准级别列表
export function getStandardLevels() {
  return request({
    url: "/common/standard/levels",
    method: "get",
  });
}
